export function trackEvent(eventName, eventData = {}) {
    if (window.dataLayer) {
        dataLayer.push({
            event: eventName,
            ...eventData
        });
        console.log(`GTM Evento enviado: ${eventName}`, eventData);
    } else {
        console.warn("dataLayer no está definido");
    }
}